import {CSS} from '../constants/rules'

export default (content) => {
	return `<span id="injected-rules-markup">${CSS}${content}</span>`;
}

